<template>
  <div class="col-12">
    <b-card>
      <div slot="header">
        <strong v-text="$lang.change_person_identity" />
      </div>
      <LoadingSpinner :loading="loading" :text="$lang.sending_data" />
      <PersonIdentityForm
        v-show="!loading"
        :oldName="oldName"
        :oldFamily="oldFamily"
        :oldNationalCode="oldNationalCode"
        :parentPermissions="parentPermissions"
        @close="close"
        @submit="submit"
      />
    </b-card>
  </div>
</template>

<script>
import PersonIdentityForm from "./../forms/PersonIdentityForm";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr, includes } from "ramda";

export default {
  name: "add-person-identity",
  inject: ["personIdentityRepository"],
  components: {
    PersonIdentityForm,
    LoadingSpinner,
  },
  props: {
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    code: {
      type: [String, Number],
      default: null,
    },
    oldName: {
      type: String,
      default: "",
    },
    oldFamily: {
      type: String,
      default: "",
    },
    oldNationalCode: {
      type: String,
      default: "",
    },
    adminIdentityChange: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    pathOr,
    includes,
    close(refresh = false) {
      this.$emit("close", refresh);
    },
    async submit(getPayload) {
      try {
        this.loading = true;
        const { name, family, national_code } = getPayload;

        if (name === this.oldName) {
          return this.$notify.warning(
            "نام جدید و نام فعلی شما یکسان می باشند."
          );
        }

        if (family === this.oldFamily) {
          return this.$notify.warning(
            "نام خانوادگی جدید و نام خانوادگی فعلی شما یکسان می باشند."
          );
        }

        if (national_code === this.oldNationalCode) {
          return this.$notify.warning(
            "کد ملی جدید و کد ملی فعلی شما یکسان می باشند."
          );
        }

        const payload = { name, family, national_code };
        const response = await this.personIdentityRepository.create(
          payload,
          this.code,
          this.adminIdentityChange
        );
        this.$notify.success(response.data.message);
        this.close(true);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
